<template>
  <section
    class="component-dea9b99e"
    resmed-component-name="feature_mask_selector_text_cta_info"
    v-bind:style="{
      'background-image': `url(${acf.layout['background-image']})`,
    }"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row">
          <!-- col-xl-5 offset-lg-1 order-2 order-md-0 -->
          <div class="col-lg-5 mb-5 mb-lg-0">
            <hgroup>
              <h3 v-html="acf.headline_h3"></h3>
              <h1 v-html="acf.headline_h1"></h1>
            </hgroup>

            <div class="call-to-action">
              <a
                v-bind:href="acf.cta.href"
                v-bind:target="acf.cta.target"
                class="btn cta-pill filled-red icon right-arrow"
                >{{ acf.cta.text }}</a
              >
              <span class="duration">Only takes 2 minutes</span>
            </div>
          </div>
          <div class="col-lg-6 offset-lg-1">
            <div class="description">
              <eyebrow-icon
                v-bind:eyebrowicon="{ color: 'white', icon: 'important' }"
              ></eyebrow-icon>
              <div v-html="acf.description"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-dea9b99e", // feature_mask_selector_text_cta_info
  props: ["acf"],
  data() {
    return {
      //
    };
  },
  created() {
    bus.$emit("navigation:reversed", true);
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/variables";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-dea9b99e {
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;

  @media (min-width: 992px) {
    padding-top: $nav-lg-height;
  }
}

.component {
  padding: 3rem 0;

  @media (min-width: 768px) {
    padding: 5rem 0 3rem 0;
  }

  @media (min-width: 992px) {
    padding: 7rem 0 8rem 0;
  }

  h1 {
    margin-bottom: 2rem;
  }

  hgroup {
    @media (min-width: 768px) and (max-width: 992px) {
      max-width: 460px;
    }
  }

  .description {
    background-color: $cc-resmed-sa-purple;
    box-shadow: 0 16px 16px 0 rgba(0, 0, 0, 0.3);
    border-radius: 6px;
    padding: 5rem 2rem 3rem 2rem;

    @media (min-width: 768px) {
      padding: 5rem 5rem 4rem 5rem;
    }

    > div {
      position: relative;
      @extend %eyebrow-left;

      font-size: 1.125rem;
      color: $cc-resmed-white;

      &:before {
        background-color: $cc-resmed-white;
      }
    }
  }

  .call-to-action {
    @media (max-width: 575px) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .btn {
        margin-bottom: 1rem;
      }
    }

    .duration {
      @extend %body-small-bold;
      position: relative;
      min-height: 1.5rem;
      padding-left: 1.75rem;

      @media (min-width: 576px) {
        margin-left: 1.25rem;
      }

      &:before {
        position: absolute;
        left: 0;
        top: 0;
        content: "";
        width: 1.5rem;
        height: 1.325rem;
        background-image: url(#{$assets}/images/icon-clock.png);
        background-position: left center;
        background-size: 1.325rem;
        background-repeat: no-repeat;
      }
    }
  }
}
</style>

<style lang="scss">
@import "../../css/abstracts/colors";

// /deep/ or ::v-deep or >>> nothing works
.component-dea9b99e {
  h1 > span {
    font-family: "Plus Jakarta Sans";
    font-weight: 700;
    color: $cc-resmed-sa-purple;
  }
}
</style>